import axios from '@/axios';
import _ from 'lodash';

let accessToken = localStorage.accessToken;
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

export default {

  namespaced: true,

  actions: {

    async getRates({commit}, { order_id, collection_date }) {
      try {
        let pickup_date = collection_date.toISOString().split('T')[0];
        let res = await axios.get(`/easyparcel/rate/${order_id}/${pickup_date}`);
        let key = `${order_id}:${pickup_date}`;
        let data = res.data.data;

        data.sort((a, b) => {
          let price1 = parseFloat(a.price);
          let price2 = parseFloat(b.price);

          if (isNaN(price1)) price1 = 0;
          if (isNaN(price2)) price2 = 0;

          if (price1 < price2) return -1;
          if (price1 > price2) return 1;
          return 0;
        });

        commit('SET_ORDER_RATE', { key, rate: data});
        return data;
      }catch(e) {
        console.log(e);
        throw new Error("Cannot get rates from EasyParcel");
      }
    },

    async submitOrder({commit, dispatch}, params) {
      let data = {
        order_id: params.order_id,
        service_id: params.service_id,
        collection_date: params.collection_date,
        organization_fulfillment_provider_id: params.organization_fulfillment_provider_id,
      }

      try {
        let res = await axios.post(`/easyparcel/order`, data);
        return res.data.data;
      } catch(e) {
        console.log(e); //debug result
        throw new Error("Failed processing order with easyparcel");
      }
    },

  },

  mutations: {

    SET_ORDER_RATE (state, payload) {
      state.rates = payload.rate;
    },

  },

  states: {
    rates: {},  // for each order, it will hold the rates
  }
}
